<header class="m-0 p-0">
  <nav class="navbar navbar-expand-lg bg-secondary m-0 p-0"
       data-bs-theme="dark">
    <div class="container-fluid ps-0">
      <img src="ema-logo-app.svg" id="LogoRectangle">
      <div class="collapse navbar-collapse">
        <ul class="navbar-nav me-auto mb-2 mb-lg-0">
          <ng-container *ngIf="!isMaintenance">
          <li class="nav-item" *ngFor="let item of menuItems">
            <span class="d-inline-block" data-bs-toggle="tooltip" title="{{ item.tooltipMsg }}">
              <a class="nav-link" [ngClass]="{'selectedSection': this.authService.selectedSection == item.route}"
               [hidden]="!item.permission"
                (click)="loadSection(item.route)">{{ item.label }}</a>
              </span>
          </li>
          </ng-container>
        </ul>
        <app-user-info class="d-flex navbar-text"></app-user-info>
      </div>
    </div>
  </nav>
</header>